import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ChevronLeftIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M15.7 5.3a1 1 0 0 0-1.4 0l-6 6a1 1 0 0 0 0 1.4l6 6a1 1 0 0 0 1.4-1.4L10.4 12l5.3-5.3c.4-.4.4-1 0-1.4Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default ChevronLeftIcon;
